import { MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import { useIntl } from 'react-intl'
import SportsEsportsIcon from '@mui/icons-material/SportsEsports'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { ButtonLink } from '../../../../components/wrappers/Button'

interface MenuTenantGamesProps {
  pathname: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
  nested: string
}

export const MenuTenantGames = ({
  pathname,
  toggleDrawerOnMobile,
  nested,
}: MenuTenantGamesProps) => {
  const { formatMessage } = useIntl()

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        selected={pathname.includes('/casino/tenant-games')}
        href="/casino/tenant-games"
      >
        <ListItemIcon>
          <SportsEsportsIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'casino.submenu.tenant-games.title',
          })}
        />
      </MenuItem>
    </div>
  )
}
